import React from "react";

function Content(props) {
  return <div className="card__content">{props.children}</div>;
}

export default Content;
